import { Padrao } from '../generic/padrao';

export class AdendoCondicao extends Padrao{

    override idTab = 273;

    nome: string;
    sigla: string;
}
